import { Component, Input, OnInit } from '@angular/core';
import { PageSize } from '../../../core/dto/page.size';
import { Router } from '@angular/router';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Pagination } from '../../../core/dto/pagination';
import { RepairsService } from '../../../core/services/repairs.service';
import * as _ from 'lodash';
import { SETTINGS } from '../../../core/config/common.settings';

@Component({
  selector: 'app-view-repairs',
  templateUrl: './view-repairs.component.html',
  styleUrls: ['./view-repairs.component.scss'],
})
export class ViewRepairsComponent implements OnInit {
  @Input() fleetData: any | undefined;

  filterStatus: any;
  searchText: any;
  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;

  repairsData: any[] = [];

  skeletonTableColumns: any[] = [
    'Repair No',
    'Breakdown Date',
    'Issue',
    'Repair Done By',
    'Repair Start Date',
    'Repair End Date',
    'Back to Fleet Date',
    'Actions',
  ];
  loading = false;

  constructor(
    private router: Router,
    private repairService: RepairsService,
  ) {}

  ngOnInit() {
    this.getPagedRepairs();
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedRepairs();
  }

  getPagedRepairs(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        searchValue: this.searchText,
        fleetId: this.fleetData._id,
      },
    });
    this.repairService.getRepairsPaged(payload).then((res: any) => {
      this.loading = false;
      this.repairsData = res.data;
      this.pageSize.length = res.totalItems;
    });
  }

  search(): void {
    this.getPagedRepairs();
  }

  resetSearch(): void {
    this.searchText = null;
    this.getPagedRepairs();
  }

  navigateNewRepair(): void {
    this.router.navigate([
      `admin/fleets/${this.fleetData._id}/repair/add-edit`,
    ]);
  }

  navigateToSingle(data: any): void {
    this.router.navigate([`admin/fleets/${this.fleetData._id}/repair/${data}`]);
  }

  deleteSupplier(data: any): void {
    this.repairService.deleteRepair(data).then((res) => {
      this.ngOnInit();
    });
  }

  editNavigate(data: any): void {
    this.router.navigate([
      `admin/fleets/${this.fleetData._id}/repair/add-edit/${data}`,
    ]);
  }

  hasPermission(perm: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }
}
